<div class="card" [ngClass]="cardClass">
  @if (!hidHeader) {
    <div class="card-header" [ngClass]="headerClass">
      @if (cardTitle) {
        <h5>{{ cardTitle }}</h5>
      }
      @if (options) {
        <div class="card-header-right">
          <div class="btn-group card-option">
            <button type="button" class="btn dropdown-toggle btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="pi pi-ellipsis-v"></i>
            </button>
            <ul class="list-unstyled card-option dropdown-menu dropdown-menu-right">
              <li class="dropdown-item full-card"><a href="javascript:"><span><i class="pi pi-maximize"></i> maximize</span><span style="display:none"><i class="pi pi-minimize"></i> Restore</span></a></li>
              <li class="dropdown-item minimize-card"><a href="javascript:"><span><i class="pi pi-minus"></i> collapse</span><span style="display:none"><i class="pi pi-plus"></i> expand</span></a></li>
              <li class="dropdown-item reload-card"><a href="javascript:"><i class="pi pi-refresh"></i> reload</a></li>
              <li class="dropdown-item close-card"><a href="javascript:"><i class="pi pi-trash"></i> remove</a></li>
            </ul>
          </div>
        </div>
      }
    </div>
  }
  <div class="card-body" [ngClass]="blockClass">
    <ng-content></ng-content>
  </div>
  @if (isCardFooter) {
    <div class="card-footer" [ngClass]="footerClass">
      <ng-content select=".card-footer"></ng-content>
    </div>
  }
</div>
